import { AutomationsProps } from "@/shared/data/home.v2.data";
import AccordionWithMediaSection from "./AccordionWithMediaSection";

/**
 * AutomationsSection — HomeV2's "Build Once. Sell on repeat." panel.
 *
 * The actual layout (centered header + 2-column accordion + media) now
 * lives in the reusable `AccordionWithMediaSection`. This file is kept as
 * a thin wrapper so existing HomeV2 call sites don't change and so the
 * name still describes intent ("automations section" vs the more generic
 * primitive).
 */

const AutomationsSection = (props: AutomationsProps) => {
  return <AccordionWithMediaSection {...props} />;
};

export default AutomationsSection;
